import { Form, Input } from "antd";
import { useIntl } from "react-intl";
import InputAddress from "../../../common/InputAddress";
import MapAddress from "../../../common/MapAddress";

type Props = {
  setMapInfo: any;
  mapInfo: any;
  setNewLatLng: any;
  newLatLng: any;
  isEdit: any;
  business_location: any;
  label: string;
  name: string;
  form: any;
};

const AddressLocation = ({
  setMapInfo,
  mapInfo,
  setNewLatLng,
  newLatLng,
  isEdit,
  name,
  label,
  form,
  business_location,
}: Props) => {
  const intl = useIntl();

  return (
    <div
      className={`${isEdit && "p-4 bg-white"} " w-full rounded-lg max-xl:mb-2"`}
    >
      {isEdit ? (
        <div className="">
          <InputAddress
            label={label}
            setMapInfo={setMapInfo}
            AddressFormat={mapInfo}
            name={name}
            form={form}
            setNewLatLng={setNewLatLng}
          />
          <div className="flex items-center gap-4 mb-4">
            <Form.Item
              label={intl.formatMessage({ id: "streetNameLabel" })}
              name={[name, "streetName"]}
              className="w-full h-fit !m-0"
              required={false}
              hasFeedback
            >
              <Input
                placeholder={intl.formatMessage({
                  id: "streetNamePlaceholder",
                })}
              />
            </Form.Item>
            <Form.Item
              label={intl.formatMessage({ id: "buildingLabel" })}
              name={[name, "Building"]}
              className="w-full h-fit !m-0"
              required={false}
              hasFeedback
            >
              <Input
                placeholder={intl.formatMessage({
                  id: "buildingPlaceholder",
                })}
              />
            </Form.Item>
            <Form.Item
              name={[name, "City"]}
              className="hidden w-full"
              required={false}
            >
              <Input />
            </Form.Item>
            <Form.Item
              name={[name, "Country"]}
              className="hidden w-full"
              required={false}
            >
              <Input />
            </Form.Item>
            <Form.Item
              name={[name, "District"]}
              className="hidden w-full"
              required={false}
            >
              <Input />
            </Form.Item>
          </div>
        </div>
      ) : (
        <div className="flex flex-col gap-4">
          <div>{label}</div>
          <div className="flex items-center gap-2 px-6 py-3 mb-4 overflow-auto text-center bg-white rounded-lg whitespace-nowrap">
            {mapInfo || business_location?.Address || "---"}
          </div>
        </div>
      )}
      <MapAddress
        newLatLng={newLatLng}
        setMapInfo={setMapInfo}
        name={name}
        form={form}
        setNewLatLng={setNewLatLng}
        isEdit={isEdit}
      />
    </div>
  );
};

export default AddressLocation;
